import { COUNTRIES } from '@/components/react/form/select-values/countries';
import type { AstroLocale } from '@/schemas/components/shared/i18n';

export function getCountryEnglishName(
  selected: string,
  lang: AstroLocale,
): string {
  const match = COUNTRIES.find(
    (c) => c[lang] === selected || c.en === selected,
  );
  return match ? match.en : selected;
}
